import { AnalyticsEventTopic } from '../analyticsHelper';
import { GA4ContentClickEvent, GTMBaseEvent, GtmEventType } from './gtmEventType';
import { getQueryStringValue } from './gtmEventTypeHelper';
import { GtmListingDetailClickType, ListingDetailsClickAnalyticsEvent } from './gtmListingDetailClickType';

type ReviewClickEvent = GTMBaseEvent & {
    reviewAction: 'filter' | 'sort' | 'profile' | 'write-review';
    reviewResultCount?: number;
    section?: string;
    value?: string;
    checked?: boolean;
    clickUrl?: string;
};

type ReviewClickBody = GA4ContentClickEvent & {
    destination_type?: string;
    filter_label?: string;
    filter_action?: string;
    search_type?: string;
    search_result_count?: number;
};

const BADGE_TOKENS: Record<string, string> = { hmvp: 'mvp', htr: 'ranger', htc: 'topreviewer' };

export class GtmReviewClickType extends GtmEventType {
    canHandle(event: GTMBaseEvent): boolean {
        return (
            event.topic === AnalyticsEventTopic.ANALYTICS_CLICK &&
            ['filter', 'sort', 'profile', 'write-review'].includes(event.reviewAction as string)
        );
    }

    getBody(event: ReviewClickEvent): ReviewClickBody {
        switch (event.reviewAction) {
            case 'profile':
                return {
                    event: 'custEv_contentClick',
                    click_text: 'profile click',
                    click_url: event.clickUrl,
                    element_type: 'profile button',
                    destination_type: 'external',
                    internal_driver: getQueryStringValue(event.clickUrl || '', 'd'),
                };
            case 'write-review':
                return {
                    ...new GtmListingDetailClickType().getBody(event as unknown as ListingDetailsClickAnalyticsEvent),
                    element_title: 'reviews',
                    element_type: 'button',
                };
            case 'sort':
                return {
                    event: 'custEv_sortBy',
                    click_text: event.value,
                    element_type: 'sort',
                    search_type: 'reviews sort',
                    ...(event.reviewResultCount != null ? { search_result_count: event.reviewResultCount } : {}),
                };
            default:
                return {
                    event: 'custEv_contentClick',
                    click_text:
                        event.section === 'rating'
                            ? `${event.value}-star`
                            : BADGE_TOKENS[event.value ?? ''] || event.value,
                    element_type: 'filter',
                    filter_label: event.section === 'badge' ? 'reputation' : event.section,
                    filter_action: event.elementType === 'chip' || !event.checked ? 'remove' : 'add',
                    search_type: 'reviews',
                    ...(event.reviewResultCount != null ? { search_result_count: event.reviewResultCount } : {}),
                };
        }
    }
}
